import { ContentCmsPage } from "#sitis/internal/controllers/cms/models/Content";
import { ContentMenu } from "#sitis/internal/controllers/cms/models/ContentMenu";
export class GetContentUseCase {
  constructor(agent) {
    this.agent = agent;
  }
  async getContentMenus() {
    try {
      const res = await this.agent.get("/cms/menus").then((res2) => res2._data);
      const contentMenus = {};
      for (const key in res) {
        const rawContentMenu = res[key];
        contentMenus[key] = new ContentMenu(rawContentMenu).toJSON();
      }
      return contentMenus;
    } catch (ex) {
      throw ex;
    }
  }
  async getContentPage(pageSlug) {
    try {
      const res = await this.agent.get(`/cms/page-by-path?path=${pageSlug}`).then((res2) => res2._data);
      const contentPage = new ContentCmsPage(res).toJSON();
      return contentPage;
    } catch (ex) {
      throw ex;
    }
  }
  async getContentPageById(pageId) {
    try {
      const res = await this.agent.get(`/cms/page/${pageId}`).then((res2) => res2._data);
      return new ContentCmsPage(res).toJSON();
    } catch (ex) {
      throw ex;
    }
  }
  async getContentHomePage() {
    try {
      return await this.agent.get("/cms/home").then((res) => res._data);
    } catch (ex) {
      throw ex;
    }
  }
}
